import type { ICustomControlRequestAddEditProps } from '../pages/customControls/interfaces/';
import { translateKey } from '../../translate';
import { DiagnosisConclusionSelection } from '../pages/customControls/utils/v1/DiagnosisConclusionSelection';
import { FormDivider, HeaderDivider, InputTextArea } from './common';
import { FormLabel } from './forms/FormLabel';
import { HorizontalFormGroup } from './forms/HorizontalFormGroup';
import { InputContainer } from './forms/InputContainer';

export function DiagnosisQuestionsAddEdit(props: ICustomControlRequestAddEditProps) {
    return (
        <>
            <HeaderDivider text={translateKey('request.question')} />

            <DiagnosisConclusionSelection
                conclusie_diagnose={props.request.customControlData.conclusie_diagnose}
                diagnosis={props.request.diagnosis}
                errors={props.errors}
                handleChangeConclusieDiagnose={props.handleChangeCustomControl}
                handleChangeDiagnosisConsideration={async (diagnosis) =>
                    await props.handleChange('diagnosis', diagnosis)
                }
                service={props.service}
                validateConclusieDiagnose={props.validateOneCustomControl}
                validateDiagnosisConsideration={async () => props.validateOne('diagnosis')}
            />

            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.vraag')}>
                <FormLabel isRequired>Vraag</FormLabel>
                <InputContainer>
                    <InputTextArea
                        automation="remark"
                        error={props.errors.get('customControlData.vraag')}
                        onChange={async (value) => await props.handleChangeCustomControl({ vraag: value })}
                        onDoValidate={async () => await props.validateOneCustomControl('vraag')}
                        placeholder="Stel een vraag aan een specialist..."
                        value={props.request.customControlData.vraag}
                    />
                </InputContainer>
            </HorizontalFormGroup>

            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.toelichting')}>
                <FormLabel>Toelichting</FormLabel>
                <InputContainer>
                    <InputTextArea
                        automation="explanation"
                        error={props.errors.get('customControlData.toelichting')}
                        onChange={async (value) => await props.handleChangeCustomControl({ toelichting: value })}
                        onDoValidate={async () => await props.validateOneCustomControl('toelichting')}
                        placeholder="Een toelichting, opmerkingen of vragen..."
                        value={props.request.customControlData.toelichting}
                    />
                </InputContainer>
            </HorizontalFormGroup>

            <FormDivider />
        </>
    );
}
